// React import
import { useContext } from "react";
// Context
import { AuthContext } from "../context/AuthContext";

// function to use useContext
export const useAuthContext = () => {
  // useContext variable
  const context = useContext(AuthContext);
  if (!context) throw Error("useAuthContext must be inside an AuthContextProvider");

  return context;
};
